<div #offcanvas class="offcanvas-md offcanvas-start">
  @if (viewport.down('md')) {
    <app-menu-header [offcanvas]="true" class="shadow-sm z-3"></app-menu-header>
  }
  <div class="menu-wrapper">
    <nav #nav class="accordion" [class.collapsed]="menuCollapsed$ | async">
      @if (loggedIn | async) {
        <ul class="list-unstyled flex-grow-1 mb-0">
          @for (item of topMenu; track item) {
            <ng-container *ngTemplateOutlet="menu; context: { $implicit: item }"></ng-container>
          }
        </ul>
        <ul class="list-unstyled mb-0">
          <div class="feedback px-2 pb-2 d-flex align-items-stretch flex-column">
            <button
              class="btn btn-primary d-flex"
              title="Feedback"
              (click)="onFeedback()"
              *appPermission="permissions.feedback.create"
            >
              <i class="bi bi-chat-text"></i>
              <span class="ms-3 overflow-hidden">Feedback</span>
            </button>
          </div>
          @for (item of bottomMenu; track item) {
            <ng-container *ngTemplateOutlet="menu; context: { $implicit: item }"></ng-container>
          }
        </ul>

        <ng-template #menu let-item>
          @if (item.list && item.children) {
            <app-menu-list
              [id]="item.id"
              [dropId]="item.dropId"
              [title]="item.title"
              [icon]="item.icon"
              [firstRoute]="item.children[0].link ?? item.children[0].title"
              [disabled]="!hasFeature(item.feature)"
              *appPermission="item.permission"
            >
              @for (child of item.children; track child) {
                <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: child }"></ng-container>
              }
            </app-menu-list>
          } @else {
            <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: item }"></ng-container>
          }
        </ng-template>

        <ng-template #menuItem let-item>
          <app-menu-item
            [title]="item.title"
            [icon]="item.icon"
            [offset]="item.offset"
            [link]="item.link"
            [new]="item.new"
            [beta]="item.beta"
            [exact]="item.exact"
            [disabled]="!hasFeature(item.feature)"
            *appPermission="item.permission"
          ></app-menu-item>
        </ng-template>
      }
    </nav>

    @if ((hierarchyMenuVisible$ | async) && (loggedIn | async)) {
      <app-icon-button
        class="hierarchy-toggle"
        [icon]="(hierarchyCollapsed$ | async) ? 'bi-buildings' : 'bi-chevron-bar-left'"
        (click)="toggleHierarchy()"
      ></app-icon-button>

      <app-hierarchy-menu [class.collapsed]="hierarchyCollapsed$ | async"></app-hierarchy-menu>
    }
  </div>
</div>
